import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import * as React from 'react';
// @mui
import { Container, Typography, Stack, Button, IconButton, Tabs, Tab, Box } from '@mui/material';
// Tabela
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Iconify from '../../../components/iconify';
import FilterField from '../components/FilterField';

// api
import { validateUser, getVendas, updateVenda, deleteVenda } from '../../api';
import config from '../../../config.json';
import PopoverFiltroBasico from '../../PopoverFiltroBasico';
import ModalLoading from '../../ModalLoading';
import ModalConfirmacao from '../../ModalConfirmacao';
import { cores } from '../../../styles/styleUtils';

import NewSaleForm from '../NewSale/NewSaleForm';
import ImportaDocumento from '../components/ImportaDados/ImportaDocumento';
import FinanceiroLog from './FinanceiroLog';

// ----------------------------------------------------------------------

export default function Vendas() {
  const [propostas, setPropostas] = useState([]);
  const [modalLoading, setModalLoading] = useState(false);
  const [isNewSaleModalOpen, setIsNewSaleModalOpen] = useState(false);
  const [produto, setProduto] = React.useState(null);
  // "Vendas não lançadas": resumo de propostas aprovadas ainda não lançadas
  const [openNaoLancadas, setOpenNaoLancadas] = useState(false);
  const [propostasParaImportar, setPropostasParaImportar] = useState(null);
  const usuarioLogado = JSON.parse(localStorage.getItem('userData'));
  const [modalConfirmacaoDelete, setModalConfirmacaoDelete] = useState(false);
  const navigate = useNavigate();
  const [aba, setAba] = useState(0);
  // Filtro ----
  const dataAtual = new Date();
  const primeiroDiaDoMes = new Date(dataAtual.getFullYear(), dataAtual.getMonth(), 1);
  const ultimoDiaDoMes = new Date(dataAtual.getFullYear(), dataAtual.getMonth() + 1, 0);
  const emptyFiltro = {
    usuarioLogado,
    datainicial: primeiroDiaDoMes,
    datafinal: ultimoDiaDoMes,
  };
  const [filtro, setFiltro] = useState({ ...emptyFiltro });
  const [openFiltro, setOpenFiltro] = useState(null);

  useEffect(() => {
    validateuser();
  }, []);
  const validateuser = async () => {
    const teste = await validateUser();
    if (!teste.ok) {
      localStorage.removeItem('userData');
      localStorage.removeItem('userToken');
      config.user = {};
      navigate('/', { replace: true });
      window.alert('Sessão expirada, faça o login novamente');
      return;
    }
    localStorage.setItem('userData', JSON.stringify(teste.usuario));
    config.user = teste.usuario;
  };

  useEffect(() => {
    fGetPropostas(filtro);
  }, [filtro]);

  const fGetPropostas = async (filtro) => {
    try {
      const result = await getVendas(filtro);
      setPropostas(result);
    } catch (error) {
      window.alert('Erro ao consultar banco de dados');
      console.error('Erro ao buscar dados da API:', error);
    }
  };

  const handleOpenNewSaleModal = () => {
    setIsNewSaleModalOpen(true);
  };

  const handleCloseNewSaleModal = () => {
    setIsNewSaleModalOpen(false);
    setProduto(null);
    setPropostasParaImportar(null);
  };

  // Abre o resumo de não lançadas; ao escolher proposta(s), abre o Wizard já preenchido
  const abrirNaoLancadas = () => setOpenNaoLancadas(true);

  const onSelecionaNaoLancada = (propostasSelecionadas) => {
    setProduto(null);
    setPropostasParaImportar(propostasSelecionadas);
    setOpenNaoLancadas(false);
    setIsNewSaleModalOpen(true);
  };

  const handleDoubleClickTable = async (row) => {
    setProduto({ ...row, visualiza: true });
    setIsNewSaleModalOpen(true);
  };

  const onCloseFiltro = () => {
    setOpenFiltro(null);
  };

  const limparFiltro = () => {
    setFiltro({ ...emptyFiltro });
    setOpenFiltro(null);
  };

  const onConfirmFiltro = (filtroPopover) => {
    setFiltro(filtroPopover);
    setOpenFiltro(null);
  };

  const handleDeleteClick = (row) => {
    setProduto({ ...row });
    setModalConfirmacaoDelete(true);
  };

  const closeModalConfirmacaDelete = () => {
    setModalConfirmacaoDelete(false);
    setProduto(null);
  };

  const confirmDelete = async () => {
    const motivo = window.prompt('Informe o motivo do cancelamento da venda:');
    if (!motivo || motivo.trim().length < 3) {
      window.alert('O cancelamento não foi realizado. Informe um motivo válido.');
      return;
    }

    setModalLoading(true);
    const resultado = await deleteVenda(produto, motivo.trim());
    setModalLoading(false);

    if (resultado?.success === false || resultado?.ok === false) {
      window.alert(resultado?.message || resultado?.msg || 'Não foi possível cancelar a venda.');
      return;
    }

    closeModalConfirmacaDelete();
    fGetPropostas(filtro);
    setProduto(null);
  };

  const onConfirmNewSale = async (data) => {
    // O backend (criarVenda) gera as despesas de comissão/indicação, cria a obra
    // com o nome do cliente, vincula o centro de custo "Obra" e marca a(s)
    // proposta(s) como lançada(s). Aqui só salvamos a venda.
    const vendaSalva = await updateVenda(data);
    if (vendaSalva && vendaSalva.ok === false) {
      alert(`Erro ao salvar a venda: ${vendaSalva.msg || ''}`);
      return;
    }
    fGetPropostas(filtro);
    handleCloseNewSaleModal();
  };

  // Novo estado para o termo de busca
  const [searchTerm, setSearchTerm] = useState('');
  // Novo estado para os dados filtrados
  const [filteredPropostas, setFilteredPropostas] = useState([]);

  // Este useEffect reagirá a mudanças em 'propostas' ou 'searchTerm'
  useEffect(() => {
    const results = propostas.filter((row) => {
      const descricaoMatch = row.cliente?.nome?.toLowerCase().includes(searchTerm.toLowerCase());
      const descricaoMatch2 = row.vendedorAbertura?.nome?.toLowerCase().includes(searchTerm.toLowerCase());
      const descricaoMatch3 = row.vendedorFechamento?.nome?.toLowerCase().includes(searchTerm.toLowerCase());
      return descricaoMatch || descricaoMatch2 || descricaoMatch3;
    });
    setFilteredPropostas(results);
  }, [searchTerm, propostas]);
  // ----------------------

  // ----------------------

  return (
    <>
      <Helmet>
        <title> Vendas </title>
      </Helmet>

      <Container maxWidth="xl">
        {usuarioLogado.supervisor && (
          <Tabs value={aba} onChange={(_, novoValor) => setAba(novoValor)} sx={{ mb: 2 }}>
            <Tab label="Vendas" />
            <Tab label="Log Financeiro" />
          </Tabs>
        )}

        {aba === 0 && (
          <Box>
        <Stack direction={'row'} justifyContent={'space-between'}>
          <Typography variant="h4" sx={{ mb: 5 }}>
            Vendas
          </Typography>

          <Button
            onClick={(e) => setOpenFiltro(e.currentTarget)}
            variant="contained"
            startIcon={<Iconify icon="eva:search-fill" />}
            sx={{
              height: 50,
              minWidth: 100,
              backgroundColor: cores.laranja,
              marginLeft: 'auto',
              '&:hover': { backgroundColor: cores.laranjaEscuro },
            }}
          >
            Filtros
          </Button>

          <Button
            variant="contained"
            onClick={abrirNaoLancadas}
            startIcon={<Iconify icon="eva:flash-outline" />}
            sx={{
              height: 50,
              minWidth: 100,
              marginLeft: 1,
              backgroundColor: cores.laranja,
              '&:hover': { backgroundColor: cores.laranjaEscuro },
            }}
          >
            Vendas não lançadas
          </Button>

          <Button
            variant="contained"
            onClick={handleOpenNewSaleModal}
            startIcon={<Iconify icon="zondicons:add-solid" />}
            sx={{ height: 50, minWidth: 100, marginLeft: 1 }}
          >
            Adicionar
          </Button>
        </Stack>

        <FilterField setSearchTerm={setSearchTerm} searchTerm={searchTerm} label={'Filtrar por nome cliente ou vendedor'} />

        {/* ------------ Tabela ------------ */}
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="left">Cliente</TableCell>
                <TableCell align="left">Abertura</TableCell>
                <TableCell align="left">Fechamento</TableCell>
                <TableCell align="left">Unidade</TableCell>
                <TableCell align="center">Data</TableCell>
                <TableCell align="center">Valor</TableCell>
                {usuarioLogado.supervisor && <TableCell align="center"> </TableCell>}
              </TableRow>
            </TableHead>

            <TableBody>
              {filteredPropostas.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{
                    '&:last-child td, &:last-child th': { border: 0 },
                    '&:hover': { backgroundColor: 'Azure' },
                    ...(row.finalizado?.nome === 'Rejeitado' && {
                      color: 'red',
                      textDecoration: 'line-through',
                    }),
                  }}
                  onDoubleClick={() => handleDoubleClickTable(row)}
                >
                  <TableCell align="left">{row.cliente.nome}</TableCell>
                  <TableCell align="left">{row.vendedorAbertura?.nome}</TableCell>
                  <TableCell align="left">{row.vendedorFechamento?.nome}</TableCell>
                  <TableCell align="left">{row.unidade?.nome}</TableCell>
                  <TableCell align="center">
                    {new Date(row.data).toLocaleDateString('pt-BR', {
                      timeZone: 'America/Sao_Paulo',
                    })}
                  </TableCell>
                  <TableCell align="center">
                    {row.valor?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                  </TableCell>
                  {/* Ícone de cancelamento visível apenas para supervisores */}
                  {usuarioLogado.supervisor && (
                    <TableCell align="center">
                      <IconButton onClick={() => handleDeleteClick(row)}>
                        <Iconify icon="eva:trash-2-outline" width={24} height={24} />
                      </IconButton>
                    </TableCell>
                  )}
                </TableRow>
              ))}
              <TableRow>
                <TableCell align="left" colSpan={4}>
                  <strong>Total</strong>
                </TableCell>
                <TableCell align="center">
                  Quantidade: <strong>{propostas.length}</strong>
                </TableCell>
                <TableCell align="center">
                  <strong>
                    {propostas
                      .reduce((acc, curr) => acc + (curr.valor || 0), 0)
                      .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                  </strong>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
          </Box>
        )}

        {usuarioLogado.supervisor && aba === 1 && <FinanceiroLog />}
      </Container>

      {openFiltro ? (
        <PopoverFiltroBasico
          filtro={filtro}
          open={openFiltro}
          onClose={onCloseFiltro}
          onLimpar={limparFiltro}
          onConfirm={onConfirmFiltro}
        />
      ) : null}
      {/* Modal Loading */}
      {modalLoading && <ModalLoading open={modalLoading} />}

      {modalConfirmacaoDelete ? (
        <ModalConfirmacao
          title={'Tem certeza que deseja cancelar essa venda?'}
          subtitle={`${produto.cliente?.nome} - ${new Date(produto.data).toLocaleDateString()} - ${parseFloat(
            produto.valor
          ).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
          open={modalConfirmacaoDelete}
          onClose={closeModalConfirmacaDelete}
          onConfirm={confirmDelete}
        />
      ) : null}

      {openNaoLancadas && (
        <ImportaDocumento
          open={openNaoLancadas}
          handleClose={() => setOpenNaoLancadas(false)}
          onSelect={onSelecionaNaoLancada}
          type={'propostas'}
          filtroExtra={(item) =>
            usuarioLogado.supervisor ||
            item.user?._id === usuarioLogado._id ||
            item.user2?._id === usuarioLogado._id
          }
        />
      )}

      {isNewSaleModalOpen && (
        <NewSaleForm
          open={isNewSaleModalOpen}
          formData={produto}
          propostasParaImportar={propostasParaImportar}
          handleClose={handleCloseNewSaleModal}
          onConfirm={onConfirmNewSale}
        />
      )}
    </>
  );
}